import { Link } from "react-router-dom";
import { Anchor } from "lucide-react";

export default function MarketingFooter() {
  return (
    <footer className="border-t border-zinc-200 bg-white" data-testid="marketing-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-2 md:grid-cols-5 gap-8">
        <div className="col-span-2">
          <div className="flex items-center gap-2 mb-3">
            <div className="w-7 h-7 rounded-md bg-ink text-white grid place-items-center">
              <Anchor className="h-4 w-4" />
            </div>
            <span className="font-display text-[17px] font-medium tracking-tight">Seavanto</span>
          </div>
          <p className="text-sm text-zinc-600 max-w-sm">
            The complete digital operations platform for yacht owners, captains and crew —
            inventory, maintenance, logbooks and expenses in one secure place.
          </p>
        </div>
        <div>
          <div className="text-xs tracking-[0.2em] uppercase font-semibold text-zinc-500 mb-3">
            Product
          </div>
          <ul className="space-y-2 text-sm text-zinc-700">
            <li><Link to="/features">Features</Link></li>
            <li><Link to="/affiliate" data-testid="footer-affiliate-link">Affiliate program</Link></li>
            <li><Link to="/login">Sign in</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs tracking-[0.2em] uppercase font-semibold text-zinc-500 mb-3">
            Roles
          </div>
          <ul className="space-y-2 text-sm text-zinc-700">
            <li><Link to="/for-owners">Owners</Link></li>
            <li><Link to="/for-captains">Captains</Link></li>
            <li><Link to="/for-crew">Crew</Link></li>
            <li><Link to="/for-providers">Service Providers</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs tracking-[0.2em] uppercase font-semibold text-zinc-500 mb-3">
            Company
          </div>
          <ul className="space-y-2 text-sm text-zinc-700">
            <li><a href="mailto:seavanto@seavanto.io">seavanto@seavanto.io</a></li>
            <li>Dubai · Monaco · Palma</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-zinc-200">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-2 text-xs text-zinc-500">
          <div>© {new Date().getFullYear()} Seavanto Marine Software. All rights reserved.</div>
          <div>Built for the sea.</div>
        </div>
      </div>
    </footer>
  );
}
